import React from "react";

export default function LegalTerms() {
  return (
    <div className="min-h-screen bg-white py-12 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:64px_64px]" />
      
      <div className="max-w-4xl mx-auto relative z-10">
        <div className="bg-card/80 backdrop-blur-md border border-border/50 rounded-3xl p-8 shadow-2xl ring-1 ring-white/10">
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-purple-600 to-blue-600 rounded-2xl mb-4">
              <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h1 className="bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent text-3xl font-bold">
              利用規約
            </h1>
            <p className="text-muted-foreground mt-2">本規約は、Cashless Map（以下「本サービス」）の利用条件を定めるものです。</p>
          </div>

          <div className="prose prose-invert max-w-none">
            <p className="text-foreground mb-6">
              本規約は、Cashless Map（以下「本サービス」といいます）を提供するCashless Map（以下「当社」といいます）が、本サービスの利用条件を定めるものです。利用者（以下「ユーザー」といいます）は、本規約に同意のうえ本サービスを利用してください。
            </p>

            <h2 className="text-xl font-semibold text-foreground mb-4">第1条（定義）</h2>
            <ol className="text-foreground space-y-2 list-decimal list-inside">
              <li>「登録情報」とは、店舗名、所在地、決済対応（ブランド・方式）、その他ユーザーまたは第三者が本サービスに登録・掲載した一切の情報をいいます。</li>
              <li>「店舗」とは、本サービスに掲載・管理される実店舗その他事業拠点をいいます。</li>
              <li>「有料プラン」とは、月額課金で店舗を公開掲載できる機能をいいます。</li>
              <li>「ダッシュボード」とは、ユーザーが店舗情報の登録・編集・課金状況の確認等を行う管理画面をいいます。</li>
            </ol>

            <h2 className="text-xl font-semibold text-foreground mb-4 mt-8">第2条（適用・変更）</h2>
            <ol className="text-foreground space-y-2 list-decimal list-inside">
              <li>本規約は、本サービスの一切の利用に適用されます。</li>
              <li>当社は、必要と判断した場合、あらかじめ本サービス上での告知等により本規約を変更できるものとします。変更後にユーザーが本サービスを利用した場合、当該変更に同意したものとみなします。</li>
            </ol>

            <h2 className="text-xl font-semibold text-foreground mb-4 mt-8">第3条（アカウント・店舗登録）</h2>
            <ol className="text-foreground space-y-2 list-decimal list-inside">
              <li>ユーザーは、当社の定める方法によりアカウントおよび店舗を登録します。登録時のメール認証、本人確認その他の手続に協力するものとします。</li>
              <li>登録情報は真実かつ最新の内容を保持し、変更があれば速やかに更新してください。</li>
              <li>ユーザーは、アカウントの管理（パスワードの秘匿、端末・ブラウザの管理を含む）について一切の責任を負います。</li>
            </ol>

            <h2 className="text-xl font-semibold text-foreground mb-4 mt-8">第4条（料金と支払）</h2>
            <ol className="text-foreground space-y-2 list-decimal list-inside">
              <li>料金：1店舗あたり月額300円（税込）。</li>
              <li>決済方法：Stripeを用いた毎月自動更新とします。領収書等はStripeから自動送付されます。</li>
              <li>課税・為替：表示価格は税込表示です。必要に応じて税率変更・為替等により価格を改定することがあります。</li>
              <li>料金変更：当社は将来の料金を変更できます。変更は当社の定める方法で事前に告知し、告知後最初の更新日から適用します。</li>
              <li>支払不履行：カードの有効性等の理由で決済に失敗した場合、当社は店舗の非公開化、機能制限、契約の解除等の措置を講じることができます。</li>
            </ol>

            <h2 className="text-xl font-semibold text-foreground mb-4 mt-8">第5条（有料プランの開始・公開条件）</h2>
            <ol className="text-foreground space-y-2 list-decimal list-inside">
              <li>有料プランは、Checkoutの完了（Stripeでの決済の成功）が確認された時点で開始し、店舗は公開（地図・検索に表示）されます。</li>
              <li>決済が失敗・キャンセル・チャージバック等となった場合、店舗は非公開となることがあります。</li>
              <li>クーポンやプロモコードを利用できる場合、その条件（割引率・回数・有効期限等）はStripe上の設定に従います。</li>
            </ol>

            <h2 className="text-xl font-semibold text-foreground mb-4 mt-8">第6条（解約・返金）</h2>
            <ol className="text-foreground space-y-2 list-decimal list-inside">
              <li>ユーザーは、ダッシュボードまたはBilling Portalからいつでも解約できます。</li>
              <li>解約は即時適用され、日割り・按分の返金はありません。解約手続が更新日の前日までに完了していない場合、翌月分の課金が発生することがあります。</li>
              <li>解約後も、法令または当社が必要と判断する範囲で、ログ・請求情報・登録情報の一部を一定期間保存することがあります。</li>
            </ol>

            <h2 className="text-xl font-semibold text-foreground mb-4 mt-8">第7条（本サービスの内容）</h2>
            <ol className="text-foreground space-y-2 list-decimal list-inside">
              <li>本サービスは、決済手段（QRコード決済・電子マネー・国際ブランド等）で絞り込める店舗マップを提供します。</li>
              <li>当社は、機能追加・変更・停止・終了を、ユーザーへ事前に通知のうえ行うことができます（緊急の場合は事後となることがあります）。</li>
            </ol>

            <h2 className="text-xl font-semibold text-foreground mb-4 mt-8">第8条（禁止事項）</h2>
            <p className="text-foreground mb-2">ユーザーは、以下の行為をしてはなりません。</p>
            <ol className="text-foreground space-y-2 list-decimal list-inside">
              <li>登録情報について、権利者または当社の事前の書面許可なく複製、頒布、転載、改変、編集、要約、翻案、公衆送信（送信可能化を含む）、二次利用、商用利用、データベース化、機械学習用データとしての利用、その他これらに準ずる行為。</li>
              <li>スクレイピング、クロール、ボット等の自動化手段による大量取得、または過度なアクセス。</li>
              <li>登録情報を用いて、当社と競合するサービス・名簿・データベース等を作成・提供・販売・公開する行為。</li>
              <li>登録情報に含まれる連絡先等を、広告・勧誘・嫌がらせその他目的外で利用する行為。</li>
              <li>登録情報の出所を秘匿し、または当社との関係について誤認・混同を生じさせる態様での利用（例：「公式推奨」「提携」の表示）。</li>
              <li>本サービスの画面をフレーミング・ミラーリング等の方法で第三者に表示する行為。</li>
              <li>法令又は公序良俗に違反する行為、犯罪行為、またはそのおそれのある行為。</li>
              <li>本規約、ガイドラインに違反する行為、または上記に準ずる行為。</li>
            </ol>

            <h2 className="text-xl font-semibold text-foreground mb-4 mt-8">第9条（知的財産権・ライセンス）</h2>
            <ol className="text-foreground space-y-2 list-decimal list-inside">
              <li>本サービスおよび本サービスに関するプログラム、デザイン、ロゴ、文書等に係る一切の権利は当社または正当な権利者に帰属します。</li>
              <li>ユーザーは、自己が投稿・登録する情報について、当社に対し、本サービスの提供・運営・品質向上および本サービスの周知の目的で必要な範囲に限り、非独占的・無償・全世界的・サブライセンス不可の利用許諾（複製、公衆送信、表示、翻訳、形式変更等）を付与します。</li>
              <li>当社は、権利保護・法令遵守・運用上の必要により、登録情報の表示停止・削除・編集・非公開化等の措置を講じることができます。</li>
            </ol>

            <h2 className="text-xl font-semibold text-foreground mb-4 mt-8">第10条（登録情報の正確性・自己責任）</h2>
            <ol className="text-foreground space-y-2 list-decimal list-inside">
              <li>登録情報は、店舗等の第三者またはユーザーが提供・登録するものであり、当社はその正確性・最新性・完全性・適法性等を保証しません。</li>
              <li>ユーザーは、自己の責任で登録情報を利用し、必要に応じて最新情報を確認するものとします。</li>
            </ol>

            <h2 className="text-xl font-semibold text-foreground mb-4 mt-8">第11条（第三者サービスの利用）</h2>
            <ol className="text-foreground space-y-2 list-decimal list-inside">
              <li>本サービスは、Stripe（決済）やGoogle Maps等、第三者のサービスに依存します。これらのサービスの仕様変更・障害等により本サービスが中断・遅延した場合でも、当社は責任を負いません。</li>
              <li>Stripeの商標・ロゴ等は各権利者に帰属し、「決済はStripeで安全に処理」等の事実表示を除き、推奨・提携・保証を示唆する表現は行いません。</li>
            </ol>

            <h2 className="text-xl font-semibold text-foreground mb-4 mt-8">第12条（保証の否認）</h2>
            <p className="text-foreground">
              当社は、本サービスについて、事実上または法律上の瑕疵（安全性・信頼性・正確性・完全性・有用性・特定目的適合性・セキュリティ等）がないことを明示又は黙示を問わず保証しません。
            </p>

            <h2 className="text-xl font-semibold text-foreground mb-4 mt-8">第13条（免責）</h2>
            <ol className="text-foreground space-y-2 list-decimal list-inside">
              <li>当社は、ユーザー間、ユーザーと店舗、ユーザーと第三者との間で生じた取引・連絡・紛争等について、当社の故意又は重過失がある場合を除き一切の責任を負いません。</li>
              <li>登録情報の無断利用・スクレイピング・転載・二次利用等に関して、当社はこれを監視・防止する義務を負わず、これらに起因する紛争・損害について、当社の故意又は重過失がある場合を除き責任を負いません。</li>
              <li>システム障害、通信回線の混雑・故障、自然災害等の不可抗力により生じた損害について、当社の故意又は重過失がある場合を除き責任を負いません。</li>
            </ol>

            <h2 className="text-xl font-semibold text-foreground mb-4 mt-8">第14条（損害賠償の範囲）</h2>
            <p className="text-foreground">
              本サービスに関連して当社がユーザーに対して負う損害賠償責任が認められる場合でも、その上限は、当該ユーザーが過去12か月間に本サービスの利用対価として当社に実際に支払った金額の総額（無償利用の場合は金3,000円）を上限とします。ただし、当社の故意による場合はこの限りではありません。
            </p>

            <h2 className="text-xl font-semibold text-foreground mb-4 mt-8">第15条（利用制限・契約解除）</h2>
            <p className="text-foreground">
              当社は、ユーザーが本規約に違反した場合、または運用上必要と判断した場合、事前の通知なく、一時停止、非公開化、契約解除、再登録の拒絶その他必要な措置を講じることができます。
            </p>

            <h2 className="text-xl font-semibold text-foreground mb-4 mt-8">第16条（反社会的勢力の排除）</h2>
            <p className="text-foreground">
              ユーザーは、反社会的勢力に該当せず、また資金提供等の関与がないことを表明・保証します。違反が判明した場合、当社は直ちに利用停止・契約解除ができます。
            </p>

            <h2 className="text-xl font-semibold text-foreground mb-4 mt-8">第17条（個人情報・プライバシー）</h2>
            <p className="text-foreground">
              個人情報の取扱いは、別途定めるプライバシーポリシーによります。
            </p>

            <h2 className="text-xl font-semibold text-foreground mb-4 mt-8">第18条（秘密保持）</h2>
            <p className="text-foreground">
              ユーザーは、当社が秘密として開示した技術・営業・その他一切の情報を、当社の事前の書面同意なく第三者に開示・漏えいしてはなりません。
            </p>

            <h2 className="text-xl font-semibold text-foreground mb-4 mt-8">第19条（通知・連絡）</h2>
            <p className="text-foreground">
              当社からユーザーへの通知は、本サービス上の掲示、登録メールアドレスへの送信その他当社が適切と判断する方法により行います。ユーザーから当社への連絡は、customer-support-cashless@cashlessmap.comにて受け付けます。
            </p>

            <h2 className="text-xl font-semibold text-foreground mb-4 mt-8">第20条（権利義務の譲渡禁止）</h2>
            <p className="text-foreground">
              ユーザーは、当社の事前の書面による承諾なく、本規約上の地位または権利義務を第三者に譲渡・担保提供できません。
            </p>

            <h2 className="text-xl font-semibold text-foreground mb-4 mt-8">第21条（分離可能性）</h2>
            <p className="text-foreground">
              本規約のいずれかの条項が無効・違法・執行不能と判断された場合でも、その他の条項は継続して完全に効力を有するものとします。
            </p>

            <h2 className="text-xl font-semibold text-foreground mb-4 mt-8">第22条（準拠法・管轄）</h2>
            <ol className="text-foreground space-y-2 list-decimal list-inside">
              <li>本規約の準拠法は日本法とします。</li>
              <li>本サービスに関して紛争が生じた場合、東京地方裁判所を第一審の専属的合意管轄裁判所とします。</li>
            </ol>

            <h2 className="text-xl font-semibold text-foreground mb-4 mt-8">付則</h2>
            <ul className="text-foreground space-y-1 list-disc list-inside">
              <li>制定日：2025年10月19日</li>
              <li>特定商取引法に基づく表記：https://map.cashlessmap.com/legal/tokushoho</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
